import * as Sentry from '@sentry/react'

// Configuração do Sentry
export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // Filtrar erros irrelevantes
      if (event.exception) {
        const error = hint.originalException
        if (error instanceof Error) {
          // Ignorar erros específicos se necessário
          if (error.message.includes('ResizeObserver loop limit exceeded')) {
            return null
          }
        }
      }
      return event
    },
  })
}

// Utilitários para capturar eventos customizados
export const captureUserAction = (action: string, data?: Record<string, any>) => {
  Sentry.addBreadcrumb({
    message: action,
    category: 'user.action',
    data,
    level: 'info',
  })
}

export const captureError = (error: Error, context?: Record<string, any>) => {
  Sentry.withScope((scope) => {
    if (context) {
      Object.keys(context).forEach((key) => {
        scope.setContext(key, context[key])
      })
    }
    Sentry.captureException(error)
  })
}

export const setUser = (user: { id: string; email?: string; username?: string }) => {
  Sentry.setUser(user)
}

export const clearUser = () => {
  Sentry.setUser(null)
}

export const captureMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  Sentry.captureMessage(message, level)
} 